import React from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import Button from "./Button";

/**
 * Inline / footer text CTA — Button `link` variant as a router Link by default.
 * Prefer this for navigation; use `<Button variant="link">` for onClick actions.
 */
export default function TextLink({ className = "", children, as: Tag = Link, size = "md", ...rest }) {
  return (
    <Button as={Tag} variant="link" size={size} className={className} {...rest}>
      {children}
    </Button>
  );
}

/** Nav-style link (Home header) — no underline */
export function NavLink({ className = "", children, ...rest }) {
  return (
    <Link
      className={twMerge(
        "font-ui font-medium text-[13px] text-ink/55 hover:text-ink transition-colors",
        className,
      )}
      {...rest}
    >
      {children}
    </Link>
  );
}
